module.exports = __webpack_public_path__ + "img/de.00033522.png";